import { makeStyles } from "@material-ui/core/styles";
import { themeColors } from "../../components/css/themeConfig";
import { useSelector } from "react-redux";

const useStyles = () => {
  const themeName =
    useSelector((state) => state.manif?.manifParams?.Theme) || "theme1";

  return makeStyles((theme) => ({
    tableHeader: {
      backgroundColor: "#f1f1f1",
      color: theme.palette.common.black,
      fontWeight: "bold",
      border: "1px solid",
      borderColor: "#b0b0b0",
      textAlign: "center",
      verticalAlign: "middle",
      height: 30,
      width: 20,
      fontSize: 14,
    },
    tableHeaderVertical: {
      backgroundColor: "#f1f1f1",
      color: theme.palette.common.black,
      fontWeight: "bold",
      border: "1px solid",
      borderColor: "#b0b0b0",
      textAlign: "center",
      verticalAlign: "middle",
      height: 150,
    },
    tableCell: {
      border: "1px solid #b0b0b0",
      textAlign: "center",
    },
    tableRow: {
      "&:hover": {
        backgroundColor: "#f5f5f5",
      },
    },
    italicText: {
      fontStyle: "italic",
      fontSize: 12,
      color: "#808080",
    },
    rotatedHeader: {
      marginTop: -20,
      transform: "rotate(90deg)",
    },
    primaryButton: {
      backgroundColor: themeColors[themeName].headerColor,
      color: themeColors[themeName].color,
      "&:hover": {
        backgroundColor: themeColors[themeName].headerColor,
        opacity: 0.8,
      },
    },
    circularProgress: {
      color: themeColors[themeName].color,
    },
  }))();
};

export default useStyles;
